<template>
    <div class="ponds-message">
        <div class="ponds-message-container" :style="{ height: messageContainerHeight + 'px' }">
          <!-- 木耳种植信息 -->
          <div class="section-title">种植信息</div>
          <div  
          class="message1"  
          v-for="(content, index) in plantContents"  
          :key="'plant' + index"  
        > 
        <span class="dot" :style="{ backgroundColor: getRandomColor() }"></span>      
        <span class="label">{{plantLabels[index]}}</span>  
        <span class="content">{{ content }}</span>
        <span class="unit">{{plantUnits[index]}}</span>   
        </div>  
        </div>
  </div>
</template>

<script>
export default {
  name: 'EquipMessage',
  props:{
        pondsid:Number
  },
  data() {
    return {
      messageContainerHeight: 10,
      messageHeight: 50,
      plantContents: ['--', '--'],
      plantLabels: ['大棚名称: ', '种植品种: '],
      plantUnits: ['', '']
    }
  },
  computed: {
    messageContainerHei() {
      // 假设容器最多显示5条消息
      return this.messages.length * 40 + 100;
    },
  },
  methods: {
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getPlantInfo() {
      // 获取大棚信息（种植信息）
      this.request.get("/api/ponds/getponds", {
        params: {}
      }).then(res => {
        if (res && res.length > 0) {
          // 根据pondsid查找对应的大棚信息
          const pondInfo = res.find(item => item.id === this.pondsid);
          if (pondInfo) {
            // 更新种植信息
            this.plantContents = [
              pondInfo.name || '--',
              pondInfo.variety || '木耳'
            ];
          }
        }
      }).catch(error => {
        console.error('获取种植信息失败:', error);
      });
    }
  },
  watch: {
    pondsid: {
      handler() {
        if (this.pondsid) {
          this.getPlantInfo();
        }
      }
    }
  }
}
</script>

<style lang="less">
.ponds-message {
  height: 100%;
  width: 300px; /* 你可以根据需要调整宽度 */
  overflow: hidden;
  position: relative;
  border: 0px solid #ffffff;
}

.ponds-message-container {
  margin: 40px;
  width: 300px; /* 你可以根据需要调整宽度 */
  height: 100%;
  position: relative;
}

.section-title {
  color: #75deef;
  font-size: 18px;
  font-weight: bold;
  padding: 10px 0 5px 0;
  border-bottom: 1px solid rgba(117, 222, 239, 0.3);
  margin-bottom: 5px;
}

.message1 {
  color: #fff;
  font-size: 18px;
  padding: 8px 10px;
  border-bottom: 0px
}
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #75deef;
  display: inline-block;
  margin-right: 10px;
}
</style>